import React, { useEffect, useState } from "react";
import { buscarOpcoesAtivas } from "../../services/institutoDocumentosApi";

/**
 * Renderiza dinamicamente uma seção por opção ativa vinda do backend de Documentos Institucionais (card #16021).
 * Usa sempre o nome cadastrado da opção como título, na ordem que a API devolver (mais recente primeiro).
 */
function DocumentosInstitucionais() {
  const [opcoes, setOpcoes] = useState([]);

  useEffect(() => {
    let ativo = true;

    buscarOpcoesAtivas()
      .then((data) => {
        if (ativo) setOpcoes(data);
      })
      .catch((erro) => {
        // Não derruba a página: se a API falhar, a seção simplesmente não aparece.
        console.error("Falha ao buscar Documentos Institucionais:", erro);
      });

    return () => {
      ativo = false;
    };
  }, []);

  if (opcoes.length === 0) {
    return null;
  }

  return (
    <>
      {opcoes.map((opcao, indice) => {
        const ehUltima = indice === opcoes.length - 1;

        return (
          <div
            key={opcao.id}
            className={indice % 2 === 0 ? "parteBranca" : "parteBaixo"}
            style={{
              alignItems: "center",
              // A borda verde marca o fim do bloco inteiro de Documentos Institucionais, antes do footer
              borderBottom: ehUltima ? "4px solid #B1CD54" : undefined,
            }}
          >
            <p className="governanca" style={{ marginTop: "50px", paddingTop: indice % 2 !== 0 ? "40px" : undefined }}>
              {opcao.nome}
            </p>
            <div className="d-flex justify-content-center m-5">
              <ul>
                {opcao.arquivos.map((arquivo) => (
                  <li key={arquivo.id}>
                    <a href={arquivo.url} target="_blank" rel="noopener noreferrer">
                      <h4>{arquivo.nome}</h4>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        );
      })}
    </>
  );
}

export default DocumentosInstitucionais;
